import actiontypes from '../actiontypes'
import _ from 'common-tools/LodashHelper'
const queryString = require('query-string')

let actions = {}

actions[actiontypes.Router.Push] = (state, action) => {
  let newState = _.merge({}, state)

  newState.currentRoute = action.payload

  if ((action.payload || {}).search) {
    newState.currentRouteQuery = queryString.parse(action.payload.search)
  } else {
    newState.currentRouteQuery = {}
  }

  return newState
}

actions[actiontypes.Router.AddIndexRoute] = (state, action) => {
  let newState = _.merge({}, state)

  if (_.indexOf(newState.indexRoutes, action.payload) === -1) {
    newState.indexRoutes.push(action.payload)
  }

  return newState
}

export default (state = {
  indexRoutes: [],
  currentRoute: {},
  currentRouteQuery: {}
}, action) => {
  if (_.startsWith(action.type, actiontypes.Router.Prefix)) {
    return actions[action.type](state, action)
  } else {
    return state
  }
}
